export const encryptApis = {
    requestAndResponseEncript: [
        'get_advisor_clients_dropdown',
        'get_application_holder_details',
        'verify_client',
        'get_user_details_by_azureuserid',
        'get_dropdown_list_data',
        'get_advisor_user_by_firm',
        'validate_update_ms_azure_user_id'
    ],
    requestEncriptOnly: [
        'modify_application_holder_details',
        'validate_client_ssn',
        'update_hysa_account_refresh_balance',
        'update_hysa_application_account_open_details',
        'update_hysa_account_linked_accounts'
    ],
    responseEncriptOnly: [
        'advisor_client',
        'get_client_details',
        'get_advisor_deposit_accounts_list',
        'get_hysa_account_linked_accounts',
        'create_withdraw_cash_transfer',
        'create_add_cash_transfer',
        'get_add_cash_transfer_details',
        'get_advisor_hysa_account_detail',
        'account_create',
        'get_hysa_application_account_open_details',
        'get_add_existing_external_link_account_to_new_hysa_account',
        'get_auth_data',
        'get_hysa_account_details',
        'get_add_cash_movement_details',
        'get_client_details_for_mass_comm_mail',
        'get_advisor_dashbard_clients_transactions',
        'get_advisor_dashboard_account_opening_tracker_customer_queue',
        'get_advisor_dashboard_credit_card_opening_tracker_customer_queue'
    ]
}
